import { TRANSFER_STATUS } from "./TransferStatus" 

export const TRANSFER_OPTIONS = Object.keys(TRANSFER_STATUS).filter(item => typeof item === 'string' && item.length === 1).map((item) => ({ value: item as unknown as string, label: TRANSFER_STATUS[item as unknown as number] }))